import { getCookie } from 'cookies-next/client'

import { SHOP_ENV } from '../tenant'

const CUSTOMER_SUPPORT_WORKING_TIMES = {
  END_HOUR: 20,
  START_HOUR: 8,
}

export const directContactTelephoneDialogIsCustomerSupportAvailable = (
  env: SHOP_ENV,
): boolean => {
  const currentHour = new Date(Date.now()).getHours()

  //Cookie reading is for easier testing on QS through Redcare Toolbar
  if (env === SHOP_ENV.QS) {
    const cookieValue = getCookie('x-customer-support-available')
    if (cookieValue !== undefined) {
      return cookieValue === 'true'
    }

    return (
      currentHour >= CUSTOMER_SUPPORT_WORKING_TIMES.START_HOUR &&
      currentHour < CUSTOMER_SUPPORT_WORKING_TIMES.END_HOUR
    )
  }

  return (
    currentHour >= CUSTOMER_SUPPORT_WORKING_TIMES.START_HOUR &&
    currentHour < CUSTOMER_SUPPORT_WORKING_TIMES.END_HOUR
  )
}
